"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import { TeamGridProps } from "./TeamGrid.props";
import { TeamMemberCard } from "./TeamMemberCard";
import { TeamBioExpansion } from "./TeamBioExpansion";
import { Box } from "@/components/atoms/Box";

/**
 * Hook to get column count using matchMedia (more efficient than resize events)
 */
const useGridColumns = () => {
  const $ = _c(2);
  const [columns, setColumns] = useState(1);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const lgQuery = window.matchMedia("(min-width: 1024px)");
      const smQuery = window.matchMedia("(min-width: 640px)");
      const updateColumns = () => {
        if (lgQuery.matches) {
          setColumns(4);
        } else {
          if (smQuery.matches) {
            setColumns(2);
          } else {
            setColumns(1);
          }
        }
      };
      updateColumns();
      lgQuery.addEventListener("change", updateColumns);
      smQuery.addEventListener("change", updateColumns);
      return () => {
        lgQuery.removeEventListener("change", updateColumns);
        smQuery.removeEventListener("change", updateColumns);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return columns;
};

/**
 * TeamGrid component displays a responsive grid of team members.
 * Supports inline bio expansion when a member is clicked.
 */
export const TeamGrid = t0 => {
  const $ = _c(26);
  const {
    members: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const members = t2;
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const columns = useGridColumns();
  let t3;
  if ($[2] !== members || $[3] !== selectedMemberId) {
    t3 = members.find(m => m._id === selectedMemberId) || null;
    $[2] = members;
    $[3] = selectedMemberId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const selectedMember = t3;
  let t4;
  if ($[5] !== selectedMemberId) {
    t4 = m_0 => m_0._id === selectedMemberId;
    $[5] = selectedMemberId;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const selectedIndex = members.findIndex(t4);
  let insertionIndex;
  if ($[7] !== columns || $[8] !== members.length || $[9] !== selectedIndex) {
    insertionIndex = -1;
    if (selectedIndex !== -1) {
      const row = Math.floor(selectedIndex / columns);
      insertionIndex = Math.min((row + 1) * columns, members.length);
    }
    $[7] = columns;
    $[8] = members.length;
    $[9] = selectedIndex;
    $[10] = insertionIndex;
  } else {
    insertionIndex = $[10];
  }
  let t5;
  if ($[11] !== selectedMemberId) {
    t5 = id => {
      setSelectedMemberId(selectedMemberId === id ? null : id);
    };
    $[11] = selectedMemberId;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleMemberClick = t5;
  let t6;
  if ($[13] !== handleMemberClick || $[14] !== insertionIndex || $[15] !== members || $[16] !== selectedMember || $[17] !== selectedMemberId) {
    let t7;
    if ($[19] !== handleMemberClick || $[20] !== insertionIndex || $[21] !== selectedMember || $[22] !== selectedMemberId) {
      t7 = (member, index) => {
        const isSelected = selectedMemberId === member._id;
        return <React.Fragment key={member._id}><TeamMemberCard member={member} isActive={isSelected} onClick={() => handleMemberClick(member._id)} />{index + 1 === insertionIndex && <TeamBioExpansion member={selectedMember} onClose={() => setSelectedMemberId(null)} />}</React.Fragment>;
      };
      $[19] = handleMemberClick;
      $[20] = insertionIndex;
      $[21] = selectedMember;
      $[22] = selectedMemberId;
      $[23] = t7;
    } else {
      t7 = $[23];
    }
    t6 = members.map(t7);
    $[13] = handleMemberClick;
    $[14] = insertionIndex;
    $[15] = members;
    $[16] = selectedMember;
    $[17] = selectedMemberId;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[24] !== t6) {
    t7 = <Box className="w-full py-12"><Box className="container mx-auto px-4"><Box className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">{t6}</Box></Box></Box>;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
};